import { browser } from '$app/environment';
import { db } from '$lib/firestore';
import { logError } from '$lib/helpers/errors';
import {
	collection,
	query,
	where,
	getDocs,
	limit,
	orderBy,
	startAt,
	endAt
} from 'firebase/firestore';

/**
 *
 * @param {Number} count How many hits you want?
 * @param {Boolean} startAfter Do you want it to start after count?
 * @returns
 */
export async function recentWinners(count, startAfter) {
	let productArr = [];
	if (!browser) {
		return;
	}

	let hitLimit = count ? count : 5;

	try {
		const firestore = await db();

		let recentWinnersQry = await query(
			collection(firestore, 'products'),
			where('winnerChosen', '==', true),
			orderBy('endDate', 'desc'),
			limit(hitLimit)
		);

		const querySnapshot = await getDocs(recentWinnersQry);

		// Get the last visible document
		const lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

		if (startAfter) {
			let nextQry = await query(
				collection(firestore, 'products'),
				where('winnerChosen', '==', true),
				orderBy('createdAt', 'desc'),
				startAt(lastVisible),
				limit(hitLimit)
			);

			const nextQrySnapshot = await getDocs(nextQry);

			nextQrySnapshot.forEach((doc) => {
				// doc.data() is never undefined for query doc snapshots
				// console.log(doc.id, " => ", doc.data());
				productArr.push({
					id: doc.id,
					...doc.data()
				});
			});
		} else {
			querySnapshot.forEach((doc) => {
				// doc.data() is never undefined for query doc snapshots
				// console.log(doc.id, " => ", doc.data());
				productArr.push({
					id: doc.id,
					...doc.data()
				});
			});
		}
	} catch (error) {
		console.log('recentWinners error: ', error);
		logError(error, 'firestore:recentWinners');
	}
	return productArr;
}
